// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"zI x2","wrapperNeon":"zJ yc","ribbon":"zK x_","title":"zL x4","seasons":"zM x9","genres":"zN x-","buttonWrapper":"zO x6","button":"zP x7","buttonNeon":"zQ yd"};